module.exports = "\n\n<p>\n  membership works!\n</p>\n\n"